import React, { FC } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import imagePng from "images/travelhero2.png";
import HeroSearchForm from "components/HeroSearchForm/HeroSearchForm";
import HeroSearchForm2MobileFactory from "components/HeroSearchForm2Mobile/HeroSearchForm2MobileFactory";
import MobileSearch from "components/MobileSearchForm/MobileSearch";
import { useNavigate } from "react-router-dom";

export interface SectionHero3Props {
  className?: string;
}

const SectionHero3: FC<SectionHero3Props> = ({ className = "" }) => {
  const navigate = useNavigate();
  return (
    <div
      className={`nc-SectionHero3 mb-80 md:mb-52 bg-black bg-opacity-70 lg:mb-0 mx-0  lg:mx-4 lg:rounded-2xl relative ${className}`}
      data-nc-id="SectionHero3"
    >
      <div
        className="absolute inset-x-0 top-[20%]  md:top-[20%] lg:top-[15%] text-center flex flex-col items-center  mx-auto space-y-3 lg:space-y-3 xl:space-y-5"
        style={{ zIndex: 1 }}
      >
        <span className="text-xl lg:text-3xl text-center text-white bg-[#00000080] px-6 border-2 border-[#FFFFFF80] rounded-full lg:mx-0 mx-4 font-medium">
          AMK Elite Car Rentals
        </span>
        <span className="text-3xl lg:text-7xl font-bold text-center max-w-3xl text-white bg-opacity-80 px-1 lg:bg-none lg:bg-opacity-0 lg:mx-0 mx-4">
          Drive in Comfort Arrive in Style
        </span>

        <div
          className="hidden lg:block z-10 mb-12 lg:mb-0 w-full"
          style={{ marginTop: "0px" }}
        >
          <HeroSearchForm />
        </div>
        <div className="block lg:hidden !mx-auto px-3 w-full">
          <MobileSearch />
        </div>

        {/* <ButtonPrimary
          sizeClass="px-6 py-3 lg:px-8 lg:py-4 rounded-xl"
          fontSize="text-sm sm:text-base lg:text-lg font-medium"
        >
          Keep calm & travel on
        </ButtonPrimary> */}
      </div>

      <div className="relative  aspect-w-1 aspect-h-1 sm:aspect-w-4 sm:aspect-h-3 lg:aspect-w-16 lg:aspect-h-9 xl:aspect-h-8 ">
        <img
          className="absolute inset-0 object-cover w-full opacity-70 rounded-2xl"
          src={imagePng}
          alt="hero"
        />
      </div>
    </div>
  );
};

export default SectionHero3;
